import React, { useState } from 'react'

const CustomerForm = ({ customer_data, setCustomerData, errors }) => {

    const [phone, setPhone] = useState(customer_data?.phone || '+44-');

    const [show_pwd, setShowPwd] = useState(false)

    const handleSetData = (e) => {
        setCustomerData(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handleChange = (e) => {
        const value = e.target.value;
    
        // Ensure the phone number starts with +44 and allow only 10 digits after that
        if (value.startsWith('+44-')) {
          // Allow up to 13 characters (including +44)
          if (value.length <= 14 && /^[0-9]*$/.test(value.substring(4))) {
            setPhone(value);
            handleSetData(e);  // Call the external handleSetData function to propagate the change
          }
        } else {
          // If the country code is removed, reset it to +44
          setPhone('+44-');
        }
      };

    return (
        <div className='contact-section pt-0'>
            <div>

                <h2 className='pt-3 pb-2 fs-2 fw-semibold'>A Little bit about you</h2>
                <p >Just a few questions to determine the type of lesson or course you would like.</p>
            </div>

            <div className='form-inner px-md-3 px-0 py-0 mt-5'>
                <div className="row clearfix">
                    <div className=" col-sm-12 form-group">
                        <input
                            type="text"
                            name="fname"
                            value={customer_data?.fname}
                            placeholder="Full Name"
                            onChange={handleSetData}
                        />
                        <span className='badge text-red'>{errors?.fname}</span>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                        <input
                            type="text"
                            name="email"
                            value={customer_data?.email}
                            placeholder="Email Address"
                            onChange={handleSetData}
                        />
                        <span className='badge text-red'>{errors?.email}</span>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                        <input
                            type="text"
                            name="phone"
                            value={phone}
                            onKeyPress={(e) => {
                            // Allow only digits after +44
                            if (!/[0-9]/.test(e.key) || phone.length > 13) {
                                e.preventDefault();
                            }
                            }}
                            onChange={handleChange}
                            placeholder="Phone Number"
                        />
                        {/* <input
                            type="text"
                            name="phone"
                            value={customer_data?.phone}
                            onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={handleSetData}
                            placeholder="Phone Number"
                        /> */}
                        <span className='badge text-red'>{errors?.phone}</span>

                    </div>

                    <div className="col-lg-12 col-md-6 col-sm-12 form-group">
                        <input
                            type="text"
                            value={customer_data?.address}
                            name="address"
                            onChange={handleSetData}
                            placeholder="Address"
                        />
                        <span className='badge text-red'>{errors?.address}</span>

                    </div>

                    <div className="col-lg-12 col-md-6 col-sm-12 form-group">
                        <input
                            type="text"
                            name="postalcode"
                            value={customer_data?.postalcode}
                            onChange={handleSetData}
                            placeholder="Postal Code"
                        />
                        <span className='badge text-red'>{errors?.postalcode}</span>

                    </div>
                </div>
            </div>

        </div>
    )
}

export default CustomerForm